<template>
<div>
  <div style="font-size: 14px; margin-bottom: 10px;">
    <i class="fa-regular fa-clock" />&nbsp;&nbsp;
    <strong v-if="Object.keys(parsedAvailableReturnDates).length === 0">SELECIONE A DATA</strong>
    <strong v-else>SELECIONE O PERÍODO</strong>
  </div>
  <div
    v-if="formatedDateList.length > 0"
    class="container-selection">
    <div
      class="pagination-control"
      :class="{ invisible: !hasPreviousPage }"
      @click="previousPage">
      <i class="fas fa-chevron-left" />
    </div>
    <div
      class="container-dates">
      <div
        v-for="(data, i) in formatedDateList"
        :key="i"
        class="item"
        :style="{
          'background-color': dateToBRString(value) == dateToBRString(data) ? primaryColor : 'white',
          'color': dateToBRString(value) == dateToBRString(data) ? 'white' : '#2A2A2A',
        }"
        @click="selectDate(data)">
        {{ formatItem(data) }}
      </div>
    </div>
    <div
      v-if="loadingMore"
      class="pagination-control"
      style="cursor: default;"
      @click="nextPage">
      <i
        class="far fa-hourglass"
        style="color: gray; font-size: 30px;" />
    </div>
    <div
      v-else
      class="pagination-control"
      :class="{ invisible: !hasNextPage }"
      @click="nextPage">
      <i class="fas fa-chevron-right" />
    </div>
  </div>
  <div
    v-else
    style="text-align: center;">
    <i>Nenhuma data disponível</i>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

const stringToDate = function(raw) {
    const parts = raw.split('-');
    return new Date(parts[0], parts[1]-1, parts[2], 0, 0, 0, 0);
};

export default {
    components: {},
    props: {
        value: {
            validator: (v) => v instanceof Date || v == null,
            default: () => null,
            required: false
        },
        availableDays: {
            type: String,
            default: () => '[]',
            required: true
        },
        returnDays: {
            type: String,
            default: () => '[]',
            required: true
        },
        primaryColor: {
            type: String,
            default: () => '#FF0000',
            required: true
        },
        passeioId: {
            type: String,
            default: () => '0',
            required: false
        },
        minDate: {
            type: Date,
            default: () => null,
            required: false
        },
    },
    emits: ['input'],
    data() {
        const pages = [];
        const preLoadedDates = JSON.parse(this.$props.availableDays);
        if(preLoadedDates) {
            pages.push(preLoadedDates);
        }
        return {
            pages,
            currentPage: 0,
            availableReturnDates: JSON.parse(this.$props.returnDays),
            hasMoreToLoad: true,
            loadingMore: false,
        };
    },
    computed: {
        nPages() {
            return this.filteredPages.length;
        },
        hasPreviousPage() {
            return this.currentPage > 0;
        },
        hasNextPage() {
            return this.currentPage < this.nPages - 1;
        },
        dateList() {
            return this.filteredPages[this.currentPage];
        },
        formatedDateList() {
            if(!this.dateList) {
                return [];
            }
            return this.dateList.map(stringToDate);
        },
        parsedAvailableReturnDates() {
            if(
                typeof this.availableReturnDates !== 'object' ||
                Array.isArray(this.availableReturnDates) ||
                this.availableReturnDates === null
            ) {
                return {};
            }
            const chaves = Object.keys(this.availableReturnDates);
            const r = {};
            chaves.forEach(chave => {
                const novaChave = this.dateToBRString(stringToDate(chave));
                const novoValor = this.dateToBRString(stringToDate(this.availableReturnDates[chave]));
                r[novaChave] = novoValor;
            });
            return r;
        },
        filteredPages() {
            const fullList = [];
            for (let i = 0; i < this.pages.length; i++) {
                const page = this.pages[i];
                const filtered = page.filter(dateStr => {
                    if(!this.minDate) {
                        return true;
                    }
                    const parts = dateStr.split('-');
                    const date = moment(new Date(parts[0], parts[1]-1, parts[2], 23, 59, 59, 0));
                    return date.isSameOrAfter(this.minDate);
                });
                fullList.push(...filtered);
            }
            const newPages = [];
            let currentPage = [];
            for (let i = 0; i < fullList.length; i++) {
                if(currentPage.length >= 5) {
                    newPages.push(currentPage);
                    currentPage = [];
                }
                currentPage.push(fullList[i]);
            }
            if(currentPage.length > 0) {
                newPages.push(currentPage);
            }
            return newPages;
        },
    },
    watch: {
        currentPage() {
            this.loadMoreIfNecessary();
        },
    },
    mounted() {
        this.loadMore();
    },
    methods: {
        dateToBRString(date) {
            if(!date) {
                return '';
            }
            const mes = date.toLocaleDateString('pt-BR', { month: '2-digit' });
            const dia = date.toLocaleDateString('pt-BR', { day: '2-digit' });
            const ano = date.toLocaleDateString('pt-BR', { year: 'numeric' });
            const diaSemana = date.toLocaleDateString('pt-BR', { weekday: 'long' });
            return dia + '/' + mes + '/' + ano + ' (' + diaSemana + ')';
        },
        formatItem(date) {
            const dataFormatada = this.dateToBRString(date);
            if(this.parsedAvailableReturnDates[dataFormatada]) {
                return dataFormatada + ' a ' + this.parsedAvailableReturnDates[dataFormatada];
            }
            return dataFormatada;
        },
        selectDate(date) {
            this.$emit('input', date);
        },
        previousPage() {
            if(this.hasPreviousPage) {
                this.currentPage--;
            }
        },
        nextPage() {
            if(this.hasNextPage) {
                this.currentPage++;
            }
        },
        loadMoreIfNecessary() {
            if(this.currentPage == this.nPages - 1 && this.hasMoreToLoad) {
                this.loadMore();
            }
        },
        async loadMore() {
            if(this.loadingMore || !this.hasMoreToLoad) {
                return;
            }
            this.loadingMore = true;
            try {
                const lastPage = this.pages[this.pages.length - 1];
                const lastDate = lastPage[lastPage.length - 1];
                // Comece a listar a partir da última data da última página
                const uri = lastDate ? '?minDate=' + lastDate : '';
                const response = await axios.get('/disponibilidade/' + this.$props.passeioId + uri);
                const data = response.data;
                const dates = data.availableDays ? data.availableDays : data;
                const returnDates = data.availableReturnDays ? data.availableReturnDays : {};
                if(!Array.isArray(dates) || dates.length == 0) {
                    this.hasMoreToLoad = false;
                } else {
                    this.pages.push(dates);
                }
                this.availableReturnDates = {
                    ...this.availableReturnDates,
                    ...returnDates,
                };
            }
            finally {
                this.loadingMore = false;
                this.$nextTick(() => {
                    this.loadMoreIfNecessary();
                });
            }
        }
    }
};
</script>

<style scoped>
.container-selection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.pagination-control {
    width: 6%;
    text-align: center;
    font-size: 40px;
    color: #2A2A2A;
    cursor: pointer;
}
.container-dates {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    width: 88%;
    padding-left: 5px;
    padding-right: 5px;
}
.container-dates .item {
    width: 99%;
    border: 1px solid #707070;
    text-align: left;
    color: #2A2A2A;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 15px;
    padding-left: 3px;
}
</style>
